// frontend/src/components/Breadcrumbs.js
import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { breadcrumbsForPath } from '../routes';

/**
 * Auto-generated breadcrumb bar derived from the current URL.
 * Uses the centralised route definitions in routes.js.
 */
export default function Breadcrumbs() {
  const { pathname } = useLocation();
  const crumbs = breadcrumbsForPath(pathname);

  if (crumbs.length <= 1) return null; // no breadcrumb needed for top-level pages

  return (
    <nav aria-label="Breadcrumb" className="mb-4 text-sm text-gray-500 flex items-center gap-1 flex-wrap">
      {crumbs.map((crumb, idx) => {
        const isLast = idx === crumbs.length - 1;
        return (
          <React.Fragment key={crumb.path + idx}>
            {idx > 0 && <span className="mx-1 select-none">/</span>}
            {isLast ? (
              <span className="font-medium text-gray-800" aria-current="page">{crumb.label}</span>
            ) : (
              <Link to={crumb.path} className="hover:text-blue-600 hover:underline">{crumb.label}</Link>
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
}
